import * as React from 'react';
import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { addUserList, updateUserList } from '../../api/admin';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  restaurantName: '',
  restaurantId: '',
  contactNo: '',
  city: '',
  state: '',
  country: '',
  zip: '',
};

export default function UserListDialog({
  dialogOpen,
  setDialogOpen,
  selectedItem,
  action,
  setSnackbarMessage,
  setSnackbarOpen,
  setRestaurantAdmin,
  restaurantList
}) {

  console.log({ restaurantList });
  const userRoles = useSelector((state) => state.adminUser.commonData.userRoles)
  console.log({ userRoles });
  const [inputs, setInputs] = useState(initialState);

  const [isLoading, setIsLoading] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsLoading(true)
    try {
      const { data } = action === 'CREATE' ? await addUserList(inputs) : await updateUserList(selectedItem._id, inputs)
      if (data.success) {
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: true });
        setSnackbarOpen(true);
        setDialogOpen(false);

      } else {
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setIsLoading(false);
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  };

  const handleSelectRestaurant = (event) => {
    setInputs({ ...inputs, restaurantId: event.target.value, restaurantName: event.target.value })
  };

  const handleSelectRole = (event) => {
    setInputs({ ...inputs, roleId: event.target.value, roleName: event.target.value })
  };

  const handleClose = () => {
    setDialogOpen(false);
  };


  useEffect(() => {
    // console.log('in hook', action, selectedItem);
    if (action !== 'CREATE') {
      console.log('am in', selectedItem);
      setInputs({
        firstName: selectedItem.firstName,
        lastName: selectedItem.lastName,
        email: selectedItem.email,
        restaurantId: selectedItem.restaurantId,
        restaurantName: selectedItem.restaurantId,
        contactNo: selectedItem.contactNo,
        city: selectedItem.city,
      })

    }
    else {
      setInputs(initialState);

    }
  }, [dialogOpen])


  return (
    <Box>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>
          {action === 'CREATE' ? "Create" : "Edit"} Restaurant User
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>

            <TextField
              required
              margin="dense"
              name="firstName"
              label="First Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.firstName}
              onChange={handleInputChange}
            />

            <TextField
              required
              margin="dense"
              name="lastName"
              label="Last Name"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.lastName}
              onChange={handleInputChange}
            />

            <TextField
              required
              margin="dense"
              name="email"
              label="Email"
              type="email"
              fullWidth
              variant="standard"
              value={inputs.email}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="contactNo"
              label="Phone"
              inputProps={{ maxLength: 10 }}
              fullWidth
              variant="standard"
              value={inputs.contactNo}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="city"
              label="City"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.city}
              onChange={handleInputChange}
            />

            <Box sx={{ display:'flex', justifyContent:'space-between'}}>
              <FormControl variant="standard" sx={{ minWidth: 300 }}>
                <InputLabel id="demo-simple-select-standard-label">Restaurant</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-standard-label"
                  value={inputs.restaurantName}
                  onChange={handleSelectRestaurant}
                  label="Hospital"
                >
                  {restaurantList?.map((item) =>
                    <MenuItem key={item._id} value={item._id}>{item.restaurantId} - {item.restaurantName} - {item.location}</MenuItem>
                  )}

                </Select>
              </FormControl>
              <FormControl variant="standard" sx={{ minWidth: 200 }}>
                <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-standard-label"
                  value={inputs.roleName}
                  onChange={handleSelectRole}
                  label="Hospital"
                >

                  {userRoles?.map((item) =>
                    <MenuItem value={item._id}>{item.userRole}</MenuItem>
                  )}

                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant='contained' >Cancel</Button>
            <LoadingButton loading={isLoading} type='submit' variant='contained' > {action === 'CREATE' ? "Create" : "Update"}
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  )
}
